import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/en-gb';
import { SnackbarProvider } from 'notistack';
import { RecipeManagerProvider } from './context-providers/recipe-manager-provider';
import { MealPlannerProvider } from './context-providers/meal-planner-provider';
import { ShoppingListStoreProvider } from './context-providers/shopping-list-store-provider';
import { AuthProvider } from './context-providers/auth-provider';
import { DataStoreProvider } from './context-providers/datastore-provider';
import { SettingsProvider } from './context-providers/settings-provider';
import { FriendshipsProvider } from './context-providers/friendships-provider';
import { HomeProvider } from './context-providers/home-provider';
import { InvitationsProvider } from './context-providers/invitations-provider';

export default function Providers(props: any) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
                <AuthProvider>
                    <DataStoreProvider>
                        <SettingsProvider>
                            <InvitationsProvider>
                                <HomeProvider>
                                    <RecipeManagerProvider>
                                        <MealPlannerProvider>
                                            <ShoppingListStoreProvider>
                                                <FriendshipsProvider>
                                                        {props.children}
                                                </FriendshipsProvider>
                                            </ShoppingListStoreProvider>
                                        </MealPlannerProvider>
                                    </RecipeManagerProvider>
                                </HomeProvider>
                            </InvitationsProvider>
                        </SettingsProvider>
                    </DataStoreProvider>
                </AuthProvider>
            </SnackbarProvider>
        </LocalizationProvider>
    );
}
